/* tslint:disable */
/* eslint-disable */
/**
 * Coupon Service
 * Coupon Service API Docs
 *
 * The version of the OpenAPI document: v1
 * Contact: info@mrbilit.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { ApplyCouponCodeRequestDto } from '../model';
// @ts-ignore
import { ApplyCouponResult } from '../model';
// @ts-ignore
import { BusinessPartnerCouponDto } from '../model';
// @ts-ignore
import { CouponDetailsDto } from '../model';
// @ts-ignore
import { CouponDetailsDtoItem } from '../model';
// @ts-ignore
import { CouponDetailsEditRequestDto } from '../model';
// @ts-ignore
import { CouponListItemDto } from '../model';
// @ts-ignore
import { CouponType } from '../model';
// @ts-ignore
import { CouponUsageDetailsResponseDto } from '../model';
// @ts-ignore
import { CreateCouponRequestDto } from '../model';
// @ts-ignore
import { CreateCoworkerCouponRequestDto } from '../model';
// @ts-ignore
import { CreatePrivateCodeItemResponse } from '../model';
// @ts-ignore
import { CreatePrivateCouponItemRequest } from '../model';
// @ts-ignore
import { CreateReferralCouponRequestDto } from '../model';
// @ts-ignore
import { DeleteCouponUsageResponse } from '../model';
// @ts-ignore
import { EditCouponRequestDto } from '../model';
// @ts-ignore
import { GetBulkUsageDetailsRequest } from '../model';
// @ts-ignore
import { ReserveDiscountDto } from '../model';
/**
 * CouponApiApiCouponAddPrivateItemPost - axios parameter creator
 * 
 * @param {CreatePrivateCouponItemRequest} [createPrivateCouponItemRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponAddPrivateItemPostAxiosParamCreator (createPrivateCouponItemRequest?: CreatePrivateCouponItemRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Coupon/add-private-item`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(createPrivateCouponItemRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponApplyPost - axios parameter creator
 * 
 * @param {boolean} [ignoreBillStatus] 
 * @param {ApplyCouponCodeRequestDto} [applyCouponCodeRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponApplyPostAxiosParamCreator (ignoreBillStatus?: boolean, applyCouponCodeRequestDto?: ApplyCouponCodeRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Coupon/apply`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (ignoreBillStatus !== undefined) {
        localVarQueryParameter['ignoreBillStatus'] = ignoreBillStatus;
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(applyCouponCodeRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponBillCodeCodeDiscountCodeGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {string} discountCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponBillCodeCodeDiscountCodeGetAxiosParamCreator (billCode: string, discountCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiCouponBillCodeCodeDiscountCodeGet', 'billCode', billCode)
    // verify required parameter 'discountCode' is not null or undefined
    assertParamExists('apiCouponBillCodeCodeDiscountCodeGet', 'discountCode', discountCode)
    const localVarPath = `/api/Coupon/{billCode}/code/{discountCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)))
        .replace(`{${"discountCode"}}`, encodeURIComponent(String(discountCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponBillCodeCoworkerGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponBillCodeCoworkerGetAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiCouponBillCodeCoworkerGet', 'billCode', billCode)
    const localVarPath = `/api/Coupon/{billCode}/coworker`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponCoworkerPost - axios parameter creator
 * 
 * @param {CreateCoworkerCouponRequestDto} [createCoworkerCouponRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponCoworkerPostAxiosParamCreator (createCoworkerCouponRequestDto?: CreateCoworkerCouponRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Coupon/coworker`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(createCoworkerCouponRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponEditIdPut - axios parameter creator
 * 
 * @param {number} id 
 * @param {CouponDetailsEditRequestDto} [couponDetailsEditRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponEditIdPutAxiosParamCreator (id: number, couponDetailsEditRequestDto?: CouponDetailsEditRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiCouponEditIdPut', 'id', id)
    const localVarPath = `/api/Coupon/Edit/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(couponDetailsEditRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponGet - axios parameter creator
 * 
 * @param {string} [code] 
 * @param {CouponType} [type] 
 * @param {number} [categoryId] 
 * @param {number} [page] 
 * @param {number} [size] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponGetAxiosParamCreator (code?: string, type?: CouponType, categoryId?: number, page?: number, size?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Coupon`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (code !== undefined) {
        localVarQueryParameter['code'] = code;
    }

    if (type !== undefined) {
        localVarQueryParameter['type'] = type;
    }

    if (categoryId !== undefined) {
        localVarQueryParameter['categoryId'] = categoryId;
    }

    if (page !== undefined) {
        localVarQueryParameter['page'] = page;
    }

    if (size !== undefined) {
        localVarQueryParameter['size'] = size;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponIdGet - axios parameter creator
 * 
 * @param {number} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponIdGetAxiosParamCreator (id: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiCouponIdGet', 'id', id)
    const localVarPath = `/api/Coupon/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponIdPut - axios parameter creator
 * 
 * @param {number} id 
 * @param {EditCouponRequestDto} [editCouponRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponIdPutAxiosParamCreator (id: number, editCouponRequestDto?: EditCouponRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiCouponIdPut', 'id', id)
    const localVarPath = `/api/Coupon/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(editCouponRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponIdUsagesGet - axios parameter creator
 * 
 * @param {number} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponIdUsagesGetAxiosParamCreator (id: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiCouponIdUsagesGet', 'id', id)
    const localVarPath = `/api/Coupon/{id}/usages`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponListGet - axios parameter creator
 * 
 * @param {string} code 
 * @param {CouponType} [type] 
 * @param {number} [categoryId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponListGetAxiosParamCreator (code: string, type?: CouponType, categoryId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'code' is not null or undefined
    assertParamExists('apiCouponListGet', 'code', code)
    const localVarPath = `/api/Coupon/list`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (code !== undefined) {
        localVarQueryParameter['code'] = code;
    }

    if (type !== undefined) {
        localVarQueryParameter['type'] = type;
    }

    if (categoryId !== undefined) {
        localVarQueryParameter['categoryId'] = categoryId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponPartnerPartnerIdGet - axios parameter creator
 * 
 * @param {string} mobile 
 * @param {number} partnerId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponPartnerPartnerIdGetAxiosParamCreator (mobile: string, partnerId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'mobile' is not null or undefined
    assertParamExists('apiCouponPartnerPartnerIdGet', 'mobile', mobile)
    // verify required parameter 'partnerId' is not null or undefined
    assertParamExists('apiCouponPartnerPartnerIdGet', 'partnerId', partnerId)
    const localVarPath = `/api/Coupon/partner/{partnerId}`
        .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (mobile !== undefined) {
        localVarQueryParameter['mobile'] = mobile;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponPost - axios parameter creator
 * 
 * @param {CreateCouponRequestDto} [createCouponRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponPostAxiosParamCreator (createCouponRequestDto?: CreateCouponRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Coupon`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(createCouponRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponPublicPartnerPartnerIdGet - axios parameter creator
 * 
 * @param {number} partnerId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponPublicPartnerPartnerIdGetAxiosParamCreator (partnerId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'partnerId' is not null or undefined
    assertParamExists('apiCouponPublicPartnerPartnerIdGet', 'partnerId', partnerId)
    const localVarPath = `/api/Coupon/Public/partner/{partnerId}`
        .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponReferralPost - axios parameter creator
 * 
 * @param {CreateReferralCouponRequestDto} [createReferralCouponRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponReferralPostAxiosParamCreator (createReferralCouponRequestDto?: CreateReferralCouponRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Coupon/Referral`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(createReferralCouponRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponUsageBillCodeDelete - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponUsageBillCodeDeleteAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiCouponUsageBillCodeDelete', 'billCode', billCode)
    const localVarPath = `/api/Coupon/usage/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponUsageBillCodeGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponUsageBillCodeGetAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiCouponUsageBillCodeGet', 'billCode', billCode)
    const localVarPath = `/api/Coupon/usage/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponUsageBulkPost - axios parameter creator
 * 
 * @param {GetBulkUsageDetailsRequest} [getBulkUsageDetailsRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponUsageBulkPostAxiosParamCreator (getBulkUsageDetailsRequest?: GetBulkUsageDetailsRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Coupon/usage/bulk`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(getBulkUsageDetailsRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponUsageFinalizeBillCodeDelete - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponUsageFinalizeBillCodeDeleteAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiCouponUsageFinalizeBillCodeDelete', 'billCode', billCode)
    const localVarPath = `/api/Coupon/usage/finalize/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CouponApiApiCouponUsageFinalizeBillCodePut - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {boolean} [ignoreBillStatus] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CouponApiApiCouponUsageFinalizeBillCodePutAxiosParamCreator (billCode: string, ignoreBillStatus?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiCouponUsageFinalizeBillCodePut', 'billCode', billCode)
    const localVarPath = `/api/Coupon/usage/finalize/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (ignoreBillStatus !== undefined) {
        localVarQueryParameter['ignoreBillStatus'] = ignoreBillStatus;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiCouponAddPrivateItemPost operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponAddPrivateItemPostRequest
 */
export interface CouponApiApiCouponAddPrivateItemPostRequest {
    /**
     * 
     * @type {CreatePrivateCouponItemRequest}
     * @memberof CouponApiApiCouponAddPrivateItemPost
     */
    readonly createPrivateCouponItemRequest?: CreatePrivateCouponItemRequest
}

/**
 * Request parameters for apiCouponApplyPost operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponApplyPostRequest
 */
export interface CouponApiApiCouponApplyPostRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CouponApiApiCouponApplyPost
     */
    readonly ignoreBillStatus?: boolean

    /**
     * 
     * @type {ApplyCouponCodeRequestDto}
     * @memberof CouponApiApiCouponApplyPost
     */
    readonly applyCouponCodeRequestDto?: ApplyCouponCodeRequestDto
}

/**
 * Request parameters for apiCouponBillCodeCodeDiscountCodeGet operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponBillCodeCodeDiscountCodeGetRequest
 */
export interface CouponApiApiCouponBillCodeCodeDiscountCodeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponApiApiCouponBillCodeCodeDiscountCodeGet
     */
    readonly billCode: string

    /**
     * 
     * @type {string}
     * @memberof CouponApiApiCouponBillCodeCodeDiscountCodeGet
     */
    readonly discountCode: string
}

/**
 * Request parameters for apiCouponBillCodeCoworkerGet operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponBillCodeCoworkerGetRequest
 */
export interface CouponApiApiCouponBillCodeCoworkerGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponApiApiCouponBillCodeCoworkerGet
     */
    readonly billCode: string
}

/**
 * Request parameters for apiCouponCoworkerPost operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponCoworkerPostRequest
 */
export interface CouponApiApiCouponCoworkerPostRequest {
    /**
     * 
     * @type {CreateCoworkerCouponRequestDto}
     * @memberof CouponApiApiCouponCoworkerPost
     */
    readonly createCoworkerCouponRequestDto?: CreateCoworkerCouponRequestDto
}

/**
 * Request parameters for apiCouponEditIdPut operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponEditIdPutRequest
 */
export interface CouponApiApiCouponEditIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof CouponApiApiCouponEditIdPut
     */
    readonly id: number

    /**
     * 
     * @type {CouponDetailsEditRequestDto}
     * @memberof CouponApiApiCouponEditIdPut
     */
    readonly couponDetailsEditRequestDto?: CouponDetailsEditRequestDto
}

/**
 * Request parameters for apiCouponGet operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponGetRequest
 */
export interface CouponApiApiCouponGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponApiApiCouponGet
     */
    readonly code?: string

    /**
     * 
     * @type {CouponType}
     * @memberof CouponApiApiCouponGet
     */
    readonly type?: CouponType

    /**
     * 
     * @type {number}
     * @memberof CouponApiApiCouponGet
     */
    readonly categoryId?: number

    /**
     * 
     * @type {number}
     * @memberof CouponApiApiCouponGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CouponApiApiCouponGet
     */
    readonly size?: number
}

/**
 * Request parameters for apiCouponIdGet operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponIdGetRequest
 */
export interface CouponApiApiCouponIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof CouponApiApiCouponIdGet
     */
    readonly id: number
}

/**
 * Request parameters for apiCouponIdPut operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponIdPutRequest
 */
export interface CouponApiApiCouponIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof CouponApiApiCouponIdPut
     */
    readonly id: number

    /**
     * 
     * @type {EditCouponRequestDto}
     * @memberof CouponApiApiCouponIdPut
     */
    readonly editCouponRequestDto?: EditCouponRequestDto
}

/**
 * Request parameters for apiCouponIdUsagesGet operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponIdUsagesGetRequest
 */
export interface CouponApiApiCouponIdUsagesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof CouponApiApiCouponIdUsagesGet
     */
    readonly id: number
}

/**
 * Request parameters for apiCouponListGet operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponListGetRequest
 */
export interface CouponApiApiCouponListGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponApiApiCouponListGet
     */
    readonly code: string

    /**
     * 
     * @type {CouponType}
     * @memberof CouponApiApiCouponListGet
     */
    readonly type?: CouponType

    /**
     * 
     * @type {number}
     * @memberof CouponApiApiCouponListGet
     */
    readonly categoryId?: number
}

/**
 * Request parameters for apiCouponPartnerPartnerIdGet operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponPartnerPartnerIdGetRequest
 */
export interface CouponApiApiCouponPartnerPartnerIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponApiApiCouponPartnerPartnerIdGet
     */
    readonly mobile: string

    /**
     * 
     * @type {number}
     * @memberof CouponApiApiCouponPartnerPartnerIdGet
     */
    readonly partnerId: number
}

/**
 * Request parameters for apiCouponPost operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponPostRequest
 */
export interface CouponApiApiCouponPostRequest {
    /**
     * 
     * @type {CreateCouponRequestDto}
     * @memberof CouponApiApiCouponPost
     */
    readonly createCouponRequestDto?: CreateCouponRequestDto
}

/**
 * Request parameters for apiCouponPublicPartnerPartnerIdGet operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponPublicPartnerPartnerIdGetRequest
 */
export interface CouponApiApiCouponPublicPartnerPartnerIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof CouponApiApiCouponPublicPartnerPartnerIdGet
     */
    readonly partnerId: number
}

/**
 * Request parameters for apiCouponReferralPost operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponReferralPostRequest
 */
export interface CouponApiApiCouponReferralPostRequest {
    /**
     * 
     * @type {CreateReferralCouponRequestDto}
     * @memberof CouponApiApiCouponReferralPost
     */
    readonly createReferralCouponRequestDto?: CreateReferralCouponRequestDto
}

/**
 * Request parameters for apiCouponUsageBillCodeDelete operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponUsageBillCodeDeleteRequest
 */
export interface CouponApiApiCouponUsageBillCodeDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponApiApiCouponUsageBillCodeDelete
     */
    readonly billCode: string
}

/**
 * Request parameters for apiCouponUsageBillCodeGet operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponUsageBillCodeGetRequest
 */
export interface CouponApiApiCouponUsageBillCodeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponApiApiCouponUsageBillCodeGet
     */
    readonly billCode: string
}

/**
 * Request parameters for apiCouponUsageBulkPost operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponUsageBulkPostRequest
 */
export interface CouponApiApiCouponUsageBulkPostRequest {
    /**
     * 
     * @type {GetBulkUsageDetailsRequest}
     * @memberof CouponApiApiCouponUsageBulkPost
     */
    readonly getBulkUsageDetailsRequest?: GetBulkUsageDetailsRequest
}

/**
 * Request parameters for apiCouponUsageFinalizeBillCodeDelete operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponUsageFinalizeBillCodeDeleteRequest
 */
export interface CouponApiApiCouponUsageFinalizeBillCodeDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponApiApiCouponUsageFinalizeBillCodeDelete
     */
    readonly billCode: string
}

/**
 * Request parameters for apiCouponUsageFinalizeBillCodePut operation in CouponApi.
 * @export
 * @interface CouponApiApiCouponUsageFinalizeBillCodePutRequest
 */
export interface CouponApiApiCouponUsageFinalizeBillCodePutRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponApiApiCouponUsageFinalizeBillCodePut
     */
    readonly billCode: string

    /**
     * 
     * @type {boolean}
     * @memberof CouponApiApiCouponUsageFinalizeBillCodePut
     */
    readonly ignoreBillStatus?: boolean
}

/**
* 
* @param {CouponApiApiCouponAddPrivateItemPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponAddPrivateItemPost(requestParameters: CouponApiApiCouponAddPrivateItemPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponAddPrivateItemPostAxiosParamCreator(requestParameters.createPrivateCouponItemRequest, options, configuration);
    const request: () => AxiosPromise<CreatePrivateCodeItemResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponApplyPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponApplyPost(requestParameters: CouponApiApiCouponApplyPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponApplyPostAxiosParamCreator(requestParameters.ignoreBillStatus, requestParameters.applyCouponCodeRequestDto, options, configuration);
    const request: () => AxiosPromise<ApplyCouponResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponBillCodeCodeDiscountCodeGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponBillCodeCodeDiscountCodeGet(requestParameters: CouponApiApiCouponBillCodeCodeDiscountCodeGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponBillCodeCodeDiscountCodeGetAxiosParamCreator(requestParameters.billCode, requestParameters.discountCode, options, configuration);
    const request: () => AxiosPromise<ReserveDiscountDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponBillCodeCoworkerGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponBillCodeCoworkerGet(requestParameters: CouponApiApiCouponBillCodeCoworkerGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponBillCodeCoworkerGetAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<ReserveDiscountDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponCoworkerPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponCoworkerPost(requestParameters: CouponApiApiCouponCoworkerPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponCoworkerPostAxiosParamCreator(requestParameters.createCoworkerCouponRequestDto, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponEditIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponEditIdPut(requestParameters: CouponApiApiCouponEditIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponEditIdPutAxiosParamCreator(requestParameters.id, requestParameters.couponDetailsEditRequestDto, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponGet(requestParameters: CouponApiApiCouponGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponGetAxiosParamCreator(requestParameters.code, requestParameters.type, requestParameters.categoryId, requestParameters.page, requestParameters.size, options, configuration);
    const request: () => AxiosPromise<CouponDetailsDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponIdGet(requestParameters: CouponApiApiCouponIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponIdGetAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<CouponDetailsDtoItem> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponIdPut(requestParameters: CouponApiApiCouponIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponIdPutAxiosParamCreator(requestParameters.id, requestParameters.editCouponRequestDto, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponIdUsagesGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponIdUsagesGet(requestParameters: CouponApiApiCouponIdUsagesGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponIdUsagesGetAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<CouponUsageDetailsResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponListGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponListGet(requestParameters: CouponApiApiCouponListGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponListGetAxiosParamCreator(requestParameters.code, requestParameters.type, requestParameters.categoryId, options, configuration);
    const request: () => AxiosPromise<Array<CouponListItemDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponPartnerPartnerIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponPartnerPartnerIdGet(requestParameters: CouponApiApiCouponPartnerPartnerIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponPartnerPartnerIdGetAxiosParamCreator(requestParameters.mobile, requestParameters.partnerId, options, configuration);
    const request: () => AxiosPromise<BusinessPartnerCouponDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponPost(requestParameters: CouponApiApiCouponPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponPostAxiosParamCreator(requestParameters.createCouponRequestDto, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponPublicPartnerPartnerIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponPublicPartnerPartnerIdGet(requestParameters: CouponApiApiCouponPublicPartnerPartnerIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponPublicPartnerPartnerIdGetAxiosParamCreator(requestParameters.partnerId, options, configuration);
    const request: () => AxiosPromise<BusinessPartnerCouponDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponReferralPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponReferralPost(requestParameters: CouponApiApiCouponReferralPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponReferralPostAxiosParamCreator(requestParameters.createReferralCouponRequestDto, options, configuration);
    const request: () => AxiosPromise<CreatePrivateCodeItemResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponUsageBillCodeDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponUsageBillCodeDelete(requestParameters: CouponApiApiCouponUsageBillCodeDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponUsageBillCodeDeleteAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<Array<DeleteCouponUsageResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponUsageBillCodeGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponUsageBillCodeGet(requestParameters: CouponApiApiCouponUsageBillCodeGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponUsageBillCodeGetAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<CouponUsageDetailsResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponUsageBulkPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponUsageBulkPost(requestParameters: CouponApiApiCouponUsageBulkPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponUsageBulkPostAxiosParamCreator(requestParameters.getBulkUsageDetailsRequest, options, configuration);
    const request: () => AxiosPromise<Array<CouponUsageDetailsResponseDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponUsageFinalizeBillCodeDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponUsageFinalizeBillCodeDelete(requestParameters: CouponApiApiCouponUsageFinalizeBillCodeDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponUsageFinalizeBillCodeDeleteAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CouponApiApiCouponUsageFinalizeBillCodePutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CouponApiApiCouponUsageFinalizeBillCodePut(requestParameters: CouponApiApiCouponUsageFinalizeBillCodePutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CouponApiApiCouponUsageFinalizeBillCodePutAxiosParamCreator(requestParameters.billCode, requestParameters.ignoreBillStatus, options, configuration);
    const request: () => AxiosPromise<ApplyCouponResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
